import React from "react";
import SectionHero from "components/SectionHero/SectionHero";
import rightImg from "images/about-hero-right.png";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ButtonPlayMusicPlayer from "components/ButtonPlayMusicPlayer";
import Image from "components/Image";
import { DEMO_POSTS_AUDIO } from "data/posts";
import iconPlaying from "images/icon-playing.gif";
import { PauseIcon } from "@heroicons/react/24/outline";
import { PlayIcon } from "@heroicons/react/24/solid";
import "../../styles/styles.css"

const PageAbout = () => {
  const renderIcon = (playing: boolean) => {
    if (playing) 
    {
      return <Image className="w-7" src={iconPlaying} alt="" />;
    }
  }
  const renderButtonPlay = (playing: boolean) => 
    {
    return (
      <Image
        className={` nc-animation-spin rounded-full ${
          playing ? "playing" : ""
        }`}
        src={iconPlaying}
        alt="audio"
      />
    );
  };
  const renderDefaultBtnListen = (state?: "playing") => {
    return (
      <span className="w-11 h-11 flex items-center justify-center rounded-full bg-white dark:bg-neutral-800 text-primary-6000 dark:text-primary-200 shadow-lg cursor-pointer">
        {state === "playing" ? (
          <PauseIcon className="w-6 h-6" />
        ) : (
          <PlayIcon className="w-6 h-6" />
        )}
      </span>
    );
  };
  return (
    <div className={`nc-PageAbout relative`}>
      <div className="dark bg-neutral-900/95 text-white">
      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />
      <div className="container py-4 lg:py-7 space-y-4 lg:space-y-7">
        <SectionHero
          rightImg={rightImg}
          heading="À propos"
          btnText=""
          subHeading="Qu’elles soient orientées vers le domaine humain (commerce, écoles, divertissement)  ou très technique (arts urbains, constructions, tracées de voies ferrées), VisionnaireDrone envisage tout  projet à partir d’un même angle: une bonne écoute et une empathie sont des valeurs  chères à l’entreprise et mènent à une bonne compréhension, essentielle à tout succès  lorsqu’il s’agit de répondre fidèlement aux exigences précises d’un tournage."
        />
        <SectionFounder />
        <div className="relative py-16">
          <BackgroundSection />
          <SectionStatistic />
   
          <ButtonPlayMusicPlayer
          renderChildren={renderButtonPlay}
          post={DEMO_POSTS_AUDIO[0]}
          renderDefaultBtn={() => renderDefaultBtnListen()}
          renderPlayingBtn={() => renderDefaultBtnListen("playing")}
        />
        </div>
        </div>
      </div>
    </div>
  );
};

export default PageAbout;
